<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col
        :span="20"
        :xs="12"
        class="logo"
        :class="collapsed?'logo-collapse-width':'logo-width'" 
      >
      <img src="../assets/sllogo.png" class="logoImg" v-if="!collapsed"  /> 
      <span >{{sysName}}</span>
 
    </el-col>

      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">
            <!--<img src="../assets/user.jpg">-->
            {{uName}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item>设置</el-dropdown-item>-->
            <!-- 退出登录 -->
            <el-dropdown-item @click.native="cpwd">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">

      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="content-wrapper">
           	<el-row :gutter="20">
						  <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">						 
							  <div class="prdName" @click="jump('https://dist.yxcg.net')">
							  	<img src="../assets/mailiang.png"/>
							  	</div>		
							  <p class="prdName2">买量</p>
						  </el-col>
						  <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">						  
							  <div class="prdName"  @click="jump('https://sdk.yxcg.net')">
							  	<img src="../assets/mailiang2.png"/>
							  </div>	
							  <p class="prdName2">卖量</p>
						  </el-col>
						  <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">					   
					  		<div class="prdName" @click="jump('https://tongji.yxcg.net')">
					  			<img src="../assets/tongji.png"/>
					  		</div>	
					   		<p class="prdName2">统计</p>			
						  </el-col>
						  <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">
					  		<div class="prdName" @click="jump('https://cloud.yxcg.net')">
					  			<img src="../assets/cloud.png"/>
					  		</div>	
					  		<p class="prdName2">云控</p>
						 </el-col>
						  <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">
					  		<div class="prdName prdName3" @click="$router.push('/issuedApp/index')">
					  			<img src="../assets/gamecenter.png"/>
					  		</div>	
					  		<p class="prdName2">游戏管理</p>
						 </el-col>
						  <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">
					  		<div class="prdName prdName3" @click="jump('https://ucenter.yxcg.net')">
					  			<img src="../assets/users.png"/>
					  		</div>	
					  		<p class="prdName2">用户中心</p>
						 </el-col>
						  <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">
					  		<div class="prdName prdName3" @click="$router.push('/cpCompany/index')">
					  			<img src="../assets/cp.png"/>
					  		</div>	
					  		<p class="prdName2">CP管理</p>
						 </el-col>
						
						</el-row>
          </el-col>
        </div>
      </section>
      

      
    </el-col>


    <el-dialog title="修改密码" :visible.sync="updatePwd2" width="400px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="请输入原密码" label-width="120px" prop="old_password">
          <el-input style="width:200px" v-model="form.old_password" show-password></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码" label-width="120px" prop="new_password">
          <el-input style="width:200px" v-model="form.new_password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" label-width="120px" prop="checkPass">
          <el-input style="width:200px" v-model="form.checkPass" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePwd2 = false">取 消</el-button>
        <el-button type="primary" @click="changePwd">确 定</el-button>
      </div>
    </el-dialog>

  </el-row>
</template>

<script>
import { updatePwd,scpwd,sconfig } from "../api/api";

export default {
  data() {
    var nPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("新密码不能为空!"));
      } else if (value.length<6) {
        callback(new Error("密码长度不能低于6位"));
      } else {
        callback();
      }
    };
    var vPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== this.form.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
            rules: {
        old_password: [
          { required: true, message: "原密码不能为空", trigger: "change" }
        ],
        new_password: [
          { required: true,validator:nPass, trigger: "blur" }
        ],
        checkPass: [{ validator: vPass,required: true, trigger: "blur" }]
      },
      screenWidth: document.body.clientWidth,
      sysName: "小森林管理平台",
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      uName:'',
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      dialogTableVisible:false,

      updatePwd2: false,
      form:{
        old_password:'',
        new_password:'',
      },


    };
  },
    created() {
    let that = this;
    document.onkeydown = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13&&that.updatePwd2) {
        that.changePwd();
         return false;
      }
    };
  },

  methods: {
    cpwd(){
      this.form={old_password: "", new_password: ""};
      this.updatePwd2=true;
    },
    changePwd() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          scpwd(this.form, this.$cookie.getCookie("login")).then(res => {
            if(res.code==200){
              this.updatePwd2=false;
              this.$router.push({path:'/login'})
            }else{
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    jump(url){
    	window.location.href=url
    },


    onSubmit() {
      console.log("submit!");
    },
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function(a, b) {},
    //退出登录
    logout: function() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          // sessionStorage.removeItem("user");
          _this.$router.push("/login");
        })
        .catch(() => {});
    },
    //折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
  },
  mounted() {
    //获取配置文件
    sconfig(this.$cookie.getCookie("login")).then(res => {
      if (res.code == 200) {
        this.$store.config = res.data;
      }
    });
    var that = this;
    if (this.$cookie.getCookie("user")) {
      this.uName =decodeURIComponent(this.$cookie.getCookie("user"));
      this.uPwd = this.$cookie.getCookie("pwd");
      this.form.old_password=this.uPwd;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~scss_vars";

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;

    color: #fff;
    .userinfo {
      // background: $color-primary;
      // line-height: 0;
      height: 60px;
      text-align: right;
      padding-right: 35px;
      box-sizing: border-box;
      float: right;
      color:#333333;
      .userinfo-inner {
        cursor: pointer;
        color:#333333;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 10px 0px 10px;
          float: left;
        }
      }
    }
    .logo {
     /* width:230px;*/

      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
			color: #333333;
      transition: all 0.3s;
      img {
       width: 40px;
		    height: 40px;
		    display: inline-block;
		    vertical-align: middle;
       /* margin: 10px 10px 10px 18px;*/
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      /*width: 230px;*/
    }
    .logo-collapse-width {
      padding: 0;
      width: 0px;
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
    aside {
      flex: 0 0 230px;
      width: 230px;

      .el-menu {
        height: 100%;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
      .expanded {
        width: 230px !important;
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
      transition: all 0.5s;
    }
    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }
    .content-container {
      flex: 1;
   		max-width: 1200px;
      padding: 80px 150px 50px 30px;
      margin: 0 auto;
      .breadcrumb-container {
        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
      .prdName{
      	width: 150px;
      	max-height: 150px;
      	max-width: 100%;
        background-image: linear-gradient(180deg, #43de7c, #33b061); 
      	
      	color: #ffffff;
      	font-size: 20px;
      	text-align: center;
      	line-height: 250px;
      	cursor: pointer;
      	margin: 0 auto;
      	border-radius: 40px;
      	img{
      		width: 66.66%;
      		margin:16.66%;
      		
      	}
      }
      .prdName3{
      	 background-image: linear-gradient(180deg, #f5f6f8, #e5e9ec); 
      	
      	
      	
      }
      .prdName2{
      	text-align: center;
      	font-size: 18px;
      	margin-bottom: 100px;
      }

    }
    .fixRight{
      	width: 140px;
      	height: 80%;
      	position: fixed;
      	right: 0;
      	top: 10%;
      	border-left: 1px solid #f5f5f5;
      	img{
      		width: 32px;
      	}
      	.game{
      			width: 140px;
      			height: 80px;
      			text-align: center;
      			color: lightseagreen;
      			font-size: 16px;
      			margin-top: 20px;
      			cursor: pointer;
      			.txt{
      				margin: 0;
      			}
      	}
      	.users{
      		width: 140px;
      			height: 80px;
      			text-align: center;
      			color: palevioletred;
      			font-size: 16px;
      			cursor: pointer;
      			.txt{
      				margin: 0;
      			}
      	}
      }
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?20c189e8